import { useState, useEffect } from 'react'

import {
    Typography, Button, Dialog, DialogContent, DialogActions, TextField, RadioGroup, FormControlLabel, Radio, CircularProgress,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Switch
} from "@mui/material"

import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import { DiscoveryCallParticipant, FundraisingCampaignDiscoveryCall } from '../../../API'

import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

import { useAppSelector, useAppDispatch } from "../../../hooks"
import { createBackendFundraisingCampaignDiscoveryCall, getSelectedFundraisingCampaignDiscoveryCalls } from '../../../managers/redux/slices/calendar'
import { API } from 'aws-amplify'
import { getFundraisingCampaignDiscoveryCall, listDiscoveryCallParticipationByDiscoveryCall, listDiscoveryCallParticipationByFundraisingCampaign } from '../../../managers/graphql/queries'
import axios from 'axios'
import { setLoading } from '../../../managers/redux/slices/loading'
import { createFundraisingCampaignDiscoveryCall, updateFundraisingCampaign } from '../../../managers/graphql/mutations'
import { setSelectedFundraisingCampaign } from '../../../managers/redux/slices/fundraising'
import { toast } from 'react-toastify'
import { DataGrid, GridSelectionModel, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarExport, GridToolbarFilterButton } from '@mui/x-data-grid'

export default function DiscoveryCalls(props: any) {

    const dispatch = useAppDispatch()

    const selectedFundraisingCampaign = useAppSelector(state => state.fundraising.selectedCampaign)
    const selectedStaffProfile = useAppSelector(state => state.authAccount.selectedStaffProfile)
    const selectedFundraisingCampaignDiscoveryCalls = useAppSelector(state => state.calendar.selectedFundraisingCampaignDiscoveryCalls)
    const activeLoads = useAppSelector(state => state.loading.activeLoads)

    const [calendarEvents, setCalendarEvents] = useState<any>(null)

    const [selectedDiscoveryCall, setSelectedDiscoveryCall] = useState<FundraisingCampaignDiscoveryCall | null>(null)

    const [showManageDiscoverCallModal, setShowManageDiscoveryCallModal] = useState<boolean>(false)
    const [title, setTitle] = useState<string | null>(null)
    const [location, setLocation] = useState<string>('virtual')
    const [description, setDescription] = useState<string>('')
    const [startTimestamp, setStartTimestamp] = useState<number>(new Date().getTime())
    const [endTimestamp, setEndTimestamp] = useState<number>(new Date().getTime())
    const [conferencingProvider, setConferencingProvider] = useState<string>('Zoom Meeting')
    const [conferencingURL, setConferencingURL] = useState<string>('')
    const [conferencingMeetingCode, setConferencingMeetingCode] = useState<string>('')
    const [conferencingPassword, setConferencingPassword] = useState<string>('')
    const [conferencingPhone, setConferencingPhone] = useState<string[] | null>(null)

    const [selectedRows, setSelectedRows] = useState<GridSelectionModel>([])

    const [onDemandDiscoveryMeetingURL, setOnDemandDiscoveryMeetingURL] = useState<string | null>(null)
    const [onDemandDiscoveryMeetingInvitationCode, setOnDemandDiscoveryMeetingInvitationCode] = useState<string | null>(null)

    const [allDiscoveryCallParticipants, setAllDiscoveryCallParticipants] = useState<DiscoveryCallParticipant[] | null>(null)
    const [selectedDiscoveryCallParticipants, setSelectedDiscoveryCallParticipants] = useState<DiscoveryCallParticipant[] | null>(null)

    function handleClose() {
        setSelectedDiscoveryCall(null)
        setShowManageDiscoveryCallModal(false)
        setSelectedDiscoveryCallParticipants(null)
    }

    useEffect(() => {
        dispatch(getSelectedFundraisingCampaignDiscoveryCalls())
    }, [])

    useEffect(() => {
        const _discoveryCalls: any[] = []

        if (selectedFundraisingCampaignDiscoveryCalls) {
            selectedFundraisingCampaignDiscoveryCalls.map((discoveryCall) => {
                _discoveryCalls.push({
                    id: discoveryCall.id,
                    title: 'Discovery Meeting',
                    start: new Date(discoveryCall.startTimestamp),
                    end: new Date(discoveryCall.endTimestamp)
                })
            })
        }

        setCalendarEvents(_discoveryCalls)

    }, [selectedFundraisingCampaignDiscoveryCalls])

    useEffect(() => {
        (async () => {
            if (selectedDiscoveryCall && selectedStaffProfile && selectedStaffProfile.nylasCalendarToken) {
                if (selectedDiscoveryCall.nylasEventID) {
                    dispatch(setLoading({ loading: true, message: 'Loading event details...' }))
                    try {
                        const response = await axios.get(`https://9yim6q5pnf.execute-api.us-east-2.amazonaws.com/production/nylas/event?id=${selectedDiscoveryCall.nylasEventID}&access_token=${selectedStaffProfile.nylasCalendarToken}`)
                        console.log(response.data)
                        if (response.data.nylasEvent) {
                            const nylasEvent = response.data.nylasEvent
                            setLocation(nylasEvent.location)
                            setDescription(nylasEvent.description)
                            setConferencingProvider(nylasEvent.conferencing.provider)
                            setConferencingMeetingCode(nylasEvent.conferencing.details.meeting_code)
                            setConferencingURL(nylasEvent.conferencing.details.url)
                            setConferencingPassword(nylasEvent.conferencing.details.password)
                            setConferencingPhone(nylasEvent.conferencing.details.phone)
                        }
                        dispatch(setLoading({ loading: false, message: 'Loading event details...' }))
                    } catch (err) {
                        dispatch(setLoading({ loading: false, message: 'Loading event details...' }))
                        console.log(err)
                    }
                }
            }
            if (selectedDiscoveryCall && selectedDiscoveryCall.title) {
                setTitle(selectedDiscoveryCall.title)
            }
            if (selectedDiscoveryCall) {
                const getDiscoveryCallParticipantsResponse: any = await API.graphql({
                    query: `
                    query ListDiscoveryCallParticipationByDiscoveryCall(
                      $fundraisingCampaignDiscoveryCallID: ID
                      $sortDirection: ModelSortDirection
                      $filter: ModelDiscoveryCallParticipantFilterInput
                      $limit: Int
                      $nextToken: String
                    ) {
                      listDiscoveryCallParticipationByDiscoveryCall(
                        fundraisingCampaignDiscoveryCallID: $fundraisingCampaignDiscoveryCallID
                        sortDirection: $sortDirection
                        filter: $filter
                        limit: $limit
                        nextToken: $nextToken
                      ) {
                        items {
                          id
                          email
                          phoneNumber
                          firstName
                          lastName
                          authAccountID
                          fundraisingProfileID
                          fundraisingCampaignDiscoveryCallID
                          fundraisingCampaignID
                          invitationSent
                          icsString
                          status
                          recruitedByCampaignAmbassadorID
                          confirmed
                          notes
                          createdAt
                          updatedAt
                          owner
                          recruitedByCampaignAmbassador {
                            id
                            status
                            fundraisingProfileID
                            fundraisingProfile {
                                email
                                authAccountID
                                authAccount {
                                    firstName
                                    lastName
                                    primaryEmail
                                    phoneNumber
                                }
                            }
                          }
                        }
                        nextToken
                      }
                    }
                  `,
                    variables: {
                        fundraisingCampaignDiscoveryCallID: selectedDiscoveryCall.id
                    }
                })
                console.log(getDiscoveryCallParticipantsResponse.data)
                if (getDiscoveryCallParticipantsResponse.data && getDiscoveryCallParticipantsResponse.data.listDiscoveryCallParticipationByDiscoveryCall && getDiscoveryCallParticipantsResponse.data.listDiscoveryCallParticipationByDiscoveryCall.items) {
                    setSelectedDiscoveryCallParticipants(getDiscoveryCallParticipantsResponse.data.listDiscoveryCallParticipationByDiscoveryCall.items)
                }
            }
        })()

    }, [selectedDiscoveryCall])

    useEffect(() => {
        if (showManageDiscoverCallModal && selectedDiscoveryCall == null) {
            setTitle(`${selectedFundraisingCampaign ? `${selectedFundraisingCampaign.campaignName} Discovery Meeting` : 'Discovery Meeting'}`)
        } else if (showManageDiscoverCallModal && selectedDiscoveryCall && (selectedDiscoveryCall.title == null || selectedDiscoveryCall.title == undefined)) {
            setTitle(`${selectedFundraisingCampaign ? `${selectedFundraisingCampaign.campaignName} Discovery Meeting` : 'Discovery Meeting'}`)
        }
    }, [showManageDiscoverCallModal])

    useEffect(() => {
        (async () => {
            if (selectedFundraisingCampaign) {
                if (selectedFundraisingCampaign.onDemandDiscoveryMeetingURL) setOnDemandDiscoveryMeetingURL(selectedFundraisingCampaign.onDemandDiscoveryMeetingURL)
                if (selectedFundraisingCampaign.onDemandDiscoveryMeetingInvitationCode) setOnDemandDiscoveryMeetingInvitationCode(selectedFundraisingCampaign.onDemandDiscoveryMeetingInvitationCode)
                // get list of all discovery meeting participants
                const { data }: any = await API.graphql({
                    query: `
                    query ListDiscoveryCallParticipationByFundraisingCampaign(
                      $fundraisingCampaignID: ID
                      $sortDirection: ModelSortDirection
                      $filter: ModelDiscoveryCallParticipantFilterInput
                      $limit: Int
                      $nextToken: String
                    ) {
                      listDiscoveryCallParticipationByFundraisingCampaign(
                        fundraisingCampaignID: $fundraisingCampaignID
                        sortDirection: $sortDirection
                        filter: $filter
                        limit: $limit
                        nextToken: $nextToken
                      ) {
                        items {
                          id
                          email
                          phoneNumber
                          firstName
                          lastName
                          authAccountID
                          fundraisingProfileID
                          fundraisingCampaignDiscoveryCallID
                          fundraisingCampaignDiscoveryCall {
                            title
                            startTimestamp
                          }
                          fundraisingCampaignID
                          invitationSent
                          icsString
                          status
                          recruitedByCampaignAmbassadorID
                          confirmed
                          notes
                          createdAt
                          updatedAt
                          owner
                          recruitedByCampaignAmbassador {
                            id
                            status
                            fundraisingProfileID
                            fundraisingProfile {
                                email
                                authAccountID
                                authAccount {
                                    firstName
                                    lastName
                                    primaryEmail
                                    phoneNumber
                                }
                            }
                          }
                        }
                        nextToken
                      }
                    }
                  `,
                    variables: {
                        fundraisingCampaignID: selectedFundraisingCampaign.id
                    }
                })
                console.log(data)
                setAllDiscoveryCallParticipants(data.listDiscoveryCallParticipationByFundraisingCampaign.items)
            }
        })()
    }, [selectedFundraisingCampaign])

    return (
        <div className="row px-5">
            <div className="col-12 d-flex flex-row justify-content-between align-items-center">
                <div className="d-flex flex-row justify-content-center align-items-center">
                    <Typography variant="h3">Discovery Meetings</Typography>
                    <a href={`https://latent.flourishos.com/campaign/discovery-call?id=${selectedFundraisingCampaign ? selectedFundraisingCampaign.id : ''}`} target="_blank" style={{ textDecoration: 'none' }}>
                        <Button variant="outlined"
                            className="px-5 mx-3"
                        >
                            Preview
                        </Button>
                    </a>
                </div>
                {
                    selectedStaffProfile && selectedStaffProfile.nylasCalendarToken &&
                    <Button variant="contained" onClick={() => setShowManageDiscoveryCallModal(true)}>+ Add Discovery Meeting</Button>
                }
            </div>
            <div className="col-12 g-0">
                <div className="border rounded bg-white my-3 p-5 d-flex flex-column justify-content-center align-items-center">
                    <div className="d-flex flex-row w-100 justify-content-between align-items-center">
                        <Typography variant="h4">On Demand Discovery Meeting</Typography>
                        <Switch checked={selectedFundraisingCampaign && selectedFundraisingCampaign.onDemandDiscoveryMeetingEnabled ? true : false} onChange={async (e, checked) => {
                            if (selectedFundraisingCampaign) {
                                dispatch(setLoading({ loading: true, message: 'Updating Campaign...' }))
                                const { data }: any = await API.graphql({
                                    query: updateFundraisingCampaign,
                                    variables: {
                                        input: {
                                            id: selectedFundraisingCampaign.id,
                                            onDemandDiscoveryMeetingEnabled: checked
                                        }
                                    }
                                })
                                dispatch(setSelectedFundraisingCampaign({ id: selectedFundraisingCampaign.id }))
                                dispatch(setLoading({ loading: false, message: '' }))
                            }
                        }} />
                    </div>
                    {
                        selectedFundraisingCampaign && selectedFundraisingCampaign.onDemandDiscoveryMeetingEnabled == true && selectedStaffProfile ?
                            <div className="d-flex flex-row w-100 justify-content-between align-items-center">
                                <TextField
                                    label="On Demand Discovery Meeting URL"
                                    className="me-3 mt-3"
                                    fullWidth
                                    value={onDemandDiscoveryMeetingURL}
                                    onChange={(e) => setOnDemandDiscoveryMeetingURL(e.target.value)}
                                />
                                <TextField
                                    label="On Demand Invitation Code"
                                    className="me-3 mt-3"
                                    fullWidth
                                    value={onDemandDiscoveryMeetingInvitationCode}
                                    onChange={(e) => setOnDemandDiscoveryMeetingInvitationCode(e.target.value)}
                                />
                                <Button variant="contained" className="mt-3" onClick={async () => {
                                    dispatch(setLoading({ loading: true, message: 'Updating Campaign...' }))
                                    if (onDemandDiscoveryMeetingURL && onDemandDiscoveryMeetingURL != '') {
                                        if (selectedFundraisingCampaign.onDemandDiscoveryMeetingID) {
                                            const { data }: any = await API.graphql({
                                                query: updateFundraisingCampaign,
                                                variables: {
                                                    input: {
                                                        id: selectedFundraisingCampaign.id,
                                                        onDemandDiscoveryMeetingURL: onDemandDiscoveryMeetingURL,
                                                        onDemandDiscoveryMeetingInvitationCode: onDemandDiscoveryMeetingInvitationCode
                                                    }
                                                }
                                            })
                                        } else {
                                            const createOnDemandFundraisingCallResponse: any = await API.graphql({
                                                query: createFundraisingCampaignDiscoveryCall,
                                                variables: {
                                                    input: {
                                                        title: 'On Demand Discovery Meeting',
                                                        organizationID: selectedFundraisingCampaign.organizationID,
                                                        fundraisingCampaignID: selectedFundraisingCampaign.id,
                                                        staffProfileID: selectedStaffProfile.id,
                                                        startTimestamp: new Date(),
                                                        endTimestamp: new Date(),
                                                        latentHosted: false
                                                    }
                                                }
                                            })
                                            const { data }: any = await API.graphql({
                                                query: updateFundraisingCampaign,
                                                variables: {
                                                    input: {
                                                        id: selectedFundraisingCampaign.id,
                                                        onDemandDiscoveryMeetingURL: onDemandDiscoveryMeetingURL,
                                                        onDemandDiscoveryMeetingID: createOnDemandFundraisingCallResponse.data.createFundraisingCampaignDiscoveryCall.id,
                                                        onDemandDiscoveryMeetingInvitationCode: onDemandDiscoveryMeetingInvitationCode
                                                    }
                                                }
                                            })
                                        }
                                    } else {
                                        toast.error('You have to add a URL before saving the On Demand Discovery Meeting.', { containerId: 'main' })
                                    }
                                    dispatch(setSelectedFundraisingCampaign({ id: selectedFundraisingCampaign.id }))
                                    dispatch(setLoading({ loading: false, message: '' }))
                                }}>Save</Button>
                            </div>
                            :
                            <div></div>
                    }
                </div>
            </div>
            <div className="col-12 border rounded bg-white p-5">
                <FullCalendar
                    timeZone='local'
                    plugins={[dayGridPlugin]}
                    initialView="dayGridMonth"
                    events={calendarEvents ? calendarEvents : []}
                    eventClick={async (info) => {
                        console.log(info)

                        const { data }: any = await API.graphql({
                            query: getFundraisingCampaignDiscoveryCall,
                            variables: {
                                id: info.event._def.publicId
                            }
                        })

                        setSelectedDiscoveryCall(data.getFundraisingCampaignDiscoveryCall)
                        setShowManageDiscoveryCallModal(true)
                    }}
                />
            </div>
            <div className="col-12 g-0 w-100 mt-3">
                {
                    selectedFundraisingCampaign ?
                        <DataGrid
                            // checkboxSelection
                            // onSelectionModelChange={(newSelectionModel) => {
                            //     console.log(newSelectionModel)
                            //     setSelectedRows(newSelectionModel);
                            // }}
                            disableSelectionOnClick
                            style={{ minHeight: '50vh', height: '75vh', width: '100%', backgroundColor: 'white', borderRadius: 5 }}
                            className="p-3"
                            components={{
                                Toolbar: () => (
                                    <GridToolbarContainer className="w-100 d-flex flex-column justify-content-start align-items-center p-3">
                                        <div className="d-flex flex-row justify-content-between align-items-center w-100">
                                            <Typography variant="h3">Discovery Meeting Participants</Typography>
                                            <div className="d-flex flex-row justify-content-center align-items-center">
                                                <GridToolbarExport csvOptions={{ fileName: `${selectedFundraisingCampaign.campaignName ? selectedFundraisingCampaign.campaignName : 'LatentCampaign'}_DiscoveryCallParticipants_${new Date().toLocaleString()}` }} />
                                                <GridToolbarFilterButton />
                                                <GridToolbarColumnsButton />
                                            </div>
                                        </div>
                                    </GridToolbarContainer>
                                )
                            }}
                            columns={
                                [
                                    { field: 'firstName', headerName: 'First name', width: 130 },
                                    { field: 'lastName', headerName: 'Last name', width: 130 },
                                    { field: 'email', headerName: 'Email', width: 200 },
                                    { field: 'phoneNumber', headerName: 'Phone Number', width: 200 },
                                    { field: 'discoveryMeeting', headerName: 'Discovery Meeting', width: 200 },
                                    { field: 'recruitedBy', headerName: 'Recruited By', width: 200 },
                                    { field: 'recruitedByEmail', headerName: 'Recruited By - Email', width: 200 },
                                    { field: 'recruitedByPhoneNumber', headerName: 'Recruited By - Phone Number', width: 200 },
                                    { field: 'onApp', headerName: 'On app?', width: 150 }
                                ]
                            }
                            rows={allDiscoveryCallParticipants ? allDiscoveryCallParticipants.map((discoveryCallParticipant: DiscoveryCallParticipant) => {
                                return {
                                    id: discoveryCallParticipant.id,
                                    firstName: discoveryCallParticipant.firstName,
                                    lastName: discoveryCallParticipant.lastName,
                                    email: discoveryCallParticipant.email,
                                    phoneNumber: discoveryCallParticipant.phoneNumber,
                                    discoveryMeeting: discoveryCallParticipant.fundraisingCampaignDiscoveryCall ? new Date(discoveryCallParticipant.fundraisingCampaignDiscoveryCall.startTimestamp).toLocaleString([], { dateStyle: 'short', timeStyle: 'short' }) : '',
                                    recruitedBy: discoveryCallParticipant.recruitedByCampaignAmbassador && discoveryCallParticipant.recruitedByCampaignAmbassador.fundraisingProfile && discoveryCallParticipant.recruitedByCampaignAmbassador.fundraisingProfile.authAccount ? `${discoveryCallParticipant.recruitedByCampaignAmbassador.fundraisingProfile.authAccount.firstName} ${discoveryCallParticipant.recruitedByCampaignAmbassador.fundraisingProfile.authAccount.lastName}` : '',
                                    recruitedByEmail: discoveryCallParticipant.recruitedByCampaignAmbassador && discoveryCallParticipant.recruitedByCampaignAmbassador.fundraisingProfile && discoveryCallParticipant.recruitedByCampaignAmbassador.fundraisingProfile.authAccount ? discoveryCallParticipant.recruitedByCampaignAmbassador.fundraisingProfile.authAccount.primaryEmail : '',
                                    recruitedByPhoneNumber: discoveryCallParticipant.recruitedByCampaignAmbassador && discoveryCallParticipant.recruitedByCampaignAmbassador.fundraisingProfile && discoveryCallParticipant.recruitedByCampaignAmbassador.fundraisingProfile.authAccount ? discoveryCallParticipant.recruitedByCampaignAmbassador.fundraisingProfile.authAccount.phoneNumber : '',
                                    onApp: discoveryCallParticipant.authAccountID ? 'Yes' : 'No'
                                }
                            }) : []}
                            onCellEditStop={async (params, e: any) => {
                                console.log(params)
                                console.log(e)
                                if (params.field == 'firstName') {

                                } else if (params.field == 'lastName') {

                                } else if (params.field == 'email') {

                                } else if (params.field == 'phoneNumber') {

                                }
                            }}
                        />
                        :
                        <></>
                }
            </div>

            <div style={{ zIndex: '10 !important' }}>
                <Dialog
                    open={showManageDiscoverCallModal}
                    onClose={() => handleClose()}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth="lg"
                    fullWidth
                    style={{ zIndex: '10 !important' }}
                >
                    <div className="p-4" style={{ zIndex: '10 !important' }}>
                        <DialogContent>
                            <div className="row">
                                <div className="col-12 col-lg-6 d-flex flex-row justify-content-start align-items-center">
                                    <Typography variant="h3">{selectedDiscoveryCall ? 'Manage' : 'Add'} a Discovery Meeting</Typography>
                                </div>
                                <div className="col-12 col-lg-6 d-flex flex-row justify-content-end align-items-center">
                                <Typography variant="body2">{selectedDiscoveryCall ? selectedDiscoveryCall.id : ''}</Typography>
                                </div>
                            </div>
                            {
                                selectedDiscoveryCall == null &&
                                <Typography variant="caption">Creating a Discovery Meeting will make you the organizer of the event. You will receive all notifications for the event and your connected calendar will be the primary manager of the event. In most cases, only the staff member organizing the Discovery Call should be the one to create this actual calendar event.</Typography>
                            }
                            <div className="row my-5">
                                <div className="col-12 col-lg-6 my-3">
                                    <TextField fullWidth label="Title" value={title} onChange={(e) => { setTitle(e.target.value) }} />
                                </div>
                                <div className="col-12 col-lg-6 my-3 d-flex flex-row justify-content-start align-items-center">
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        value={location}
                                        onChange={(e, value) => setLocation(value)}
                                    >
                                        <FormControlLabel value="virtual" control={<Radio />} label="Virtual" />
                                        <FormControlLabel value="in-person" control={<Radio disabled />} label="In person (coming soon)" />
                                    </RadioGroup>
                                </div>
                                <div className="col-12 col-lg-6 my-3">
                                    <DateTimePicker
                                        label="Start Date / Time"
                                        className="w-100"
                                        renderInput={(params) => <TextField fullWidth {...params} />}
                                        value={startTimestamp}
                                        onChange={(newValue) => {
                                            if (newValue) console.log(new Date(newValue).getTime())
                                            if (newValue) setStartTimestamp(newValue)
                                        }}
                                    />
                                </div>
                                <div className="col-12 col-lg-6 my-3">
                                    <DateTimePicker
                                        label="End Date / Time"
                                        className="w-100"
                                        renderInput={(params) => <TextField fullWidth {...params} />}
                                        value={endTimestamp}
                                        onChange={(newValue) => {
                                            if (newValue) console.log(new Date(newValue).getTime())
                                            if (newValue) setEndTimestamp(newValue)
                                        }}
                                    />
                                </div>
                                <div className="col-12 my-3">
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        value={conferencingProvider}
                                        onChange={(e, value) => setConferencingProvider(value)}
                                    >
                                        <FormControlLabel value="Zoom Meeting" control={<Radio />} label="Zoom Meeting" />
                                        <FormControlLabel value="Google Meet" control={<Radio disabled />} label="Google Meet (coming soon)" />
                                        <FormControlLabel value="Microsoft Teams" control={<Radio disabled />} label="Microsoft Teams (coming soon)" />
                                        <FormControlLabel value="Cisco Webex" control={<Radio disabled />} label="Cisco Webex (coming soon)" />
                                    </RadioGroup>
                                </div>
                                <div className="col-12 col-lg-6 my-3">
                                    <TextField fullWidth label="Conferencing URL" value={conferencingURL} onChange={(e) => setConferencingURL(e.target.value)} />
                                </div>
                                <div className="col-12 col-lg-6 my-3">
                                    <TextField fullWidth label="Conferencing Meeting Code" value={conferencingMeetingCode} onChange={(e) => setConferencingMeetingCode(e.target.value)} />
                                </div>
                                <div className="col-12 col-lg-6 my-3">
                                    <TextField fullWidth label="Conferencing Password" value={conferencingPassword} onChange={(e) => setConferencingPassword(e.target.value)} />
                                </div>
                                <div className="col-12 col-lg-6 my-3">
                                    <TextField fullWidth label="Conferencing Phone #" value={conferencingPhone ? conferencingPhone[0] : null} onChange={(e) => setConferencingPhone([e.target.value])} />
                                </div>
                            </div>
                            <div className="d-flex flex-column justify-content-center align-items-center">
                                {
                                    activeLoads == 0 ?
                                        <Button
                                            disabled={selectedDiscoveryCall ? true : false}
                                            onClick={async () => {
                                                if (selectedDiscoveryCall == null) {
                                                    const response = await dispatch(createBackendFundraisingCampaignDiscoveryCall({
                                                        title,
                                                        location,
                                                        description,
                                                        startTimestamp,
                                                        endTimestamp,
                                                        conferencingProvider,
                                                        conferencingURL,
                                                        conferencingMeetingCode,
                                                        conferencingPassword,
                                                        conferencingPhone
                                                    }))
                                                    console.log(response)
                                                    handleClose()
                                                } else {
                                                    alert('Update event...')
                                                }
                                            }}
                                            variant="contained"
                                            fullWidth
                                        >
                                            {selectedDiscoveryCall ? 'Update' : 'Create'} Discovery Meeting
                                        </Button>
                                        :
                                        <CircularProgress />
                                }
                            </div>
                            {
                                selectedDiscoveryCall && selectedDiscoveryCallParticipants &&
                                <div className="col-12 my-3">
                                    <Typography variant="h3" className="my-3 mt-5">Participants</Typography>
                                    <TableContainer component={Paper} className="w-100">
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Name</TableCell>
                                                    <TableCell align="right">Email</TableCell>
                                                    <TableCell align="right">Phone Number</TableCell>
                                                    <TableCell align="right">Recruited By</TableCell>
                                                    <TableCell align="right">On app?</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {selectedDiscoveryCallParticipants.map((discoveryCallParticipant) => (
                                                    <TableRow
                                                        key={discoveryCallParticipant.id}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell component="th" scope="row">
                                                            {`${discoveryCallParticipant.firstName} ${discoveryCallParticipant.lastName}`}
                                                        </TableCell>
                                                        <TableCell align="right">{discoveryCallParticipant.email}</TableCell>
                                                        <TableCell align="right">{discoveryCallParticipant.phoneNumber}</TableCell>
                                                        <TableCell align="right">{discoveryCallParticipant.recruitedByCampaignAmbassador && discoveryCallParticipant.recruitedByCampaignAmbassador.fundraisingProfile && discoveryCallParticipant.recruitedByCampaignAmbassador.fundraisingProfile.email ? discoveryCallParticipant.recruitedByCampaignAmbassador.fundraisingProfile.email : ''}</TableCell>
                                                        <TableCell align="right">{discoveryCallParticipant.authAccountID ? 'Yes' : 'No'}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            }
                        </DialogContent>
                    </div>
                    <DialogActions className="mt-3">
                        <Button onClick={() => handleClose()}>Close</Button>
                        {/* <Button
                        onClick={_handleClick}
                        variant="contained"
                        disabled={email != '' && email != null && !isEmail(email)}
                    >
                        Send Invitation
                    </Button> */}
                    </DialogActions>
                </Dialog>
            </div>
        </div>
    )
}